<div class="manufacturing-process-container">
    <div class="manufacturing-process-item-container">
        <div class="manufacturing-process-item-input-container">
            <mat-form-field appearance="outline" class="manufacturing-process-form-field">
                <mat-label>Manufacturing Process</mat-label>
                <input matInput #manufacturingProcessInput [(ngModel)]="manufacturingProcess"
                    class="manufacturing-process manufacturing-process-item-input"
                    (keyup.enter)="updateManufacturingProcess($event)" (keyup.escape)="cancelUpdate()"
                    (blur)="updateManufacturingProcess($event)" />
                <mat-icon matSuffix (mousedown)="clearManufacturingProcessInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
    <div class="manufacturing-process-info manufacturing-process-info-text">
        Please disclose manufacturing process used to modify surface properties in this material (if applicable).
    </div>
</div>